var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-divider"},[_c('span',[_vm._t("label")],2),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }